export default __webpack_public_path__ + "4d55c309f2aabdeba92b22ca9b8843da.jpg";